import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_AUDIT_INSIGHTS_DATA = "GET_AUDIT_INSIGHTS_DATA";

export const service = async (data) => {  
  const options: object = {
    url: "/api/DenialsPredictor/GetAuditInsightsData",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};


register(GET_AUDIT_INSIGHTS_DATA, service, mock);
